import { useFlags } from 'launchdarkly-react-client-sdk';

import Prescriptions from '~/components/maud/prescriptions';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';
import { isMedicationOrderEligibleProviderType } from '~/lib/hooks/usePatientTabsCollection';
import PageNotFound from '~/pages/404';

const PrescriptionsPage = () => {
  const { currentUser } = useGlobalContext();
  const { eprescribeIntegration: isEprescribeIntegrationEnabled } =
    useFlags<LDFlags>();

  const canViewPrescriptions =
    isEprescribeIntegrationEnabled &&
    isMedicationOrderEligibleProviderType(
      currentUser?.providerTypeDetails?.name,
    );

  if (!canViewPrescriptions) return <PageNotFound />;

  return <Prescriptions />;
};

export default PrescriptionsPage;
